/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import {
  refundSubscription,
  listTransactionForSubscription,
} from "../../../store/subscription-action";
import { formatDateToCustomString } from "../../../utils/utils";
import Loader from "../../../components/Ui/Loader";
import ConfirmPopup from "../../../components/Ui/Confirm";
const ManagerSubscriptionTransaction = ({ subscription }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectItemId, setItem] = useState(null);
  const [refresh, setRefresh] = useState(null);

  const [isPopupOpen, setIsPopupOpen] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const dataSubs = await listTransactionForSubscription(
          subscription.paypalSubscriptionId
        );
        setData(dataSubs?.data?.data?.transactions);
        setTimeout(() => {
          setLoading(false);
        }, 500);
      } catch (error) {
        toast.info("Data not found");
        setLoading(false);
      }
    };
    fetchData();
  }, [refresh]);

  const refund = () => {
    const callAPI = async () => {
      if (!selectItemId) {
        return;
      }
      setLoading(true);
      try {
        await refundSubscription(
          subscription.paypalSubscriptionId,
          selectItemId
        );
        setTimeout(() => {
          setLoading(false);
          setRefresh(Date.now());
        }, 2000);
        toast.success("Successfully");
      } catch (error) {
        toast.error(error?.response?.data?.message);
        setLoading(false);
      }
    };
    callAPI();
  };

  const dataSection = useMemo(() => {
    return (
      <table className="animate-fadeInDown w-full text-sm text-left rtl:text-right text-gray-500 ">
        <thead className="text-xs text-gray-700 uppercase bg-gray-50 ">
          <tr>
            <th scope="col" className="px-6 py-3">
              Transaction ID
            </th>
            <th scope="col" className="px-6 py-3">
              Email
            </th>
            <th scope="col" className="px-6 py-3">
              Full Amount
            </th>
            <th scope="col" className="px-6 py-3">
              Status
            </th>
            <th scope="col" className="px-6 py-3">
              Time
            </th>
            <th scope="col" className="px-6 py-3">
              <span>Action</span>
            </th>
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => (
            <tr key={index} className="bg-white border-b">
              <th
                scope="row"
                className="px-6 py-4 font-medium  whitespace-nowrap"
              >
                {item.id}
              </th>
              <td className="px-6 py-4">{item?.payer_email}</td>

              <td className="px-6 py-4">
                {item?.amount_with_breakdown?.gross_amount?.value}
              </td>
              <td className="px-6 py-4 font-semibold">{item.status}</td>
              <td className="px-6 py-4">
                {formatDateToCustomString(item.time)}
              </td>
              <td>
                {item.status === "COMPLETED" && (
                  <button
                    disabled={loading}
                    onClick={(e) => {
                      setItem(item.id);
                      setIsPopupOpen(true);
                    }}
                    className="text-white disabled:bg-slate-200 disabled:cursor-not-allowed bg-blue-700 hover:bg-blue-800 rounded focus:ring-4 focus:ring-blue-300 font-medium text-sm px-2.5 py-1 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  >
                    Refund
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }, [data, loading]);

  if (!subscription) return <div>No subscription selected</div>;

  return (
    <div>
      {loading && <Loader />}
      {data && data.length > 0 && dataSection}
      {isPopupOpen && (
        <ConfirmPopup
          isOpen={isPopupOpen}
          handleClick={() => {
            setIsPopupOpen(false);
            refund();
          }}
          title="Are you sure you want to do this action?"
          shortTitle="This action cannot be undone."
          togglePopup={() => setIsPopupOpen(false)}
        />
      )}
    </div>
  );
};

export default ManagerSubscriptionTransaction;
